export enum THESIS_PROGRESS_STEP_ENUM {
    NOT_STARTED = 'NOT_STARTED', //ยังไม่ดำเนินการ
    SUCCESS = 'SUCCESS', //ดำเนินการ
}

export const thesis_progress_step_data = [
    {
        label: "ยังไม่ดำเนินการ", // i18n-ignore: step label, translated at render site
        value: THESIS_PROGRESS_STEP_ENUM.NOT_STARTED
    },
    {
        label: "ดำเนินการ", // i18n-ignore: step label, translated at render site
        value: THESIS_PROGRESS_STEP_ENUM.SUCCESS
    },
]

export enum THESIS_PROGRESS_STATUS {
    ACTIVE = "active",
    INACTIVE = "inactive"
}